<template>
  <div>
    <CarDetail v-if="showCarDetail && vehicleString" class="mb-0" data-test="vehicleName">
      {{ vehicleString }}
    </CarDetail>
    <MobialisProgressBar
      class="mb-4 mt-3"
      :class="{ 'mt-4 pt-1': !showCarDetail || !vehicleString }"
      :numberOfSteps="$route.meta.numberOfSteps"
      :navInfo="$route.meta.navInfo"
      v-if="$route.meta.navInfo"
      data-test="progressBar"
    >
    </MobialisProgressBar>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CarDetail from '@/components/test-drive/CarDetail.vue';

export default {
  name: 'TestDriveWrapper',
  data() {
    return {};
  },
  components: {
    CarDetail,
  },
  computed: {
    ...mapGetters('vehicle', ['vehicleString']),
    showCarDetail() {
      return !this.$route.meta.hideCarDetail;
    },
  },
};
</script>

<style scoped lang="scss"></style>
